'use client';

import { Text, Stack, Heading } from '@backyard-ui/core';

import useIsClient from '@/presenters/hooks/use-is-client';

import { Item } from './Item';

const ContactInfo = () => {
  const isClient = useIsClient();

  const currentURL = isClient ? window.location.href : '';
  const text = `Ol%C3%A1,+gostaria+de+informações+sobre:+${currentURL}`;

  return (
    <Stack
      direction="column"
      spacing="2"
      className="h-auto w-full rounded-lg bg-gray-100 px-3 py-4"
    >
      <Heading size="md" asChild>
        <h2>Compre pelo telefone</h2>
      </Heading>

      <Text size="sm" color="gray-600">
        Nosso atendimento funciona das 8h às 19h, de segunda a sábado. Exceto
        domingos e feriados nacionais e feriados do Estado de São Paulo.
      </Text>

      <Item
        name={'WhatsApp'}
        link={`https://api.whatsapp.com/send?phone=551140071380&text=${text}`}
        phoneNumber={'(11) 4007-1380'}
        locale={'Nacional'}
        phoneType={'whatsapp'}
      />

      <Item
        name={'Telefone'}
        link={'tel:+55-11-4007-1380'}
        phoneNumber={'4007-1380'}
        locale={'Capitais'}
        phoneType={'phone'}
      />

      <Item
        name={'Telefone'}
        link={'tel:+55-0800-602-1380'}
        phoneNumber={'0800-602-1380'}
        locale={'Demais regiões'}
        phoneType={'phone'}
      />
    </Stack>
  );
};

export default ContactInfo;
